<template>
    <div class="chat-body">
        <chat-messages :messages="messages" :currentUser="currentUser" :group="group"></chat-messages>
        <send-messages @botMessages="botMessages" @sendMessage="sendMessage" @newPlayerMessage="newPlayerMessage"></send-messages>
        <new-message @scrollToBottom="scrollNewMessage" v-if="showIconMessage"></new-message>
    </div>
</template>
<script>
import NewMessage from './components/NewMessage.vue'
import scrollToBottomHelper from './helpers/scrollToBottom.js'
import firebaseHelper from './helpers/firebase.js'
import Firebase from 'firebase'
import firebase from './firebase/firebase.js'
import ChatMessages from './components/ChatMessages.vue'
import SendMessages from './components/SendMessages.vue'
import moment from 'moment'
moment.locale('pt-br');
import Bus from './main.js'
import { setTimeout } from 'timers';
export default {
    data(){
        return{
            messages : [],
            ref : '',
            firstAccess : true,
            showIconMessage : true,
            group : [],
            currentUser : ''
        }
    },
    components:{
        ChatMessages,
        SendMessages,
        NewMessage
    },
    props:{
        chatId : {
            type : String
        }
    },
    async created(){
        const { player, chatId, group, messages } = await this.$store.getters.getSimple(['player', 'chatId', 'group', 'messages'])
        this.messages = messages
        let self = this
        this.group = group
        this.currentUser = player
        this.$store.subscribe((mutation, state) => {
            if(self.firstAccess & state.persistence.messages){
                this.messages = state.persistence.messages ? state.persistence.messages : []
                this.group = state.persistence.group ? state.persistence.group : []
                self.firstAccess = false
                return
            }
            this.group = state.persistence.group ? state.persistence.group : []
            this.messages = state.persistence.messages ? state.persistence.messages : []
        })
        this.$store.commit('DELETE_NEW_MESSAGE')
        Bus.$on('scrollToBottom', this.scrollToBottom)
        Bus.$on('toggleIcon', this.toggleIcon)
        Bus.$on('firstMessages', this.firstMessages)
        Bus.$on('newMessage', this.newMessage)
        Bus.$on('botMessages', this.botMessages)
        Bus.$on('newPlayerMessage', this.newPlayerMessage)
        Bus.$on('scrollToTop', this.scrollToTop)
    },
    async destroyed(){
        Bus.$off('scrollToBottom')
        Bus.$off('toggleIcon')
        Bus.$off('botMessages')
        this.$store.commit('DELETE_NEW_MESSAGE')
    },
    methods: {
        newMessage(message){
            this.messages.push(message)
        },
        async sendMessage(message){
            const { player, chatId } = await this.$store.getters.getSimple(['player', 'chatId'])
            let sentOn = moment().format('YYYY-MM-DD HH:mm:ss')
            let newMessage = {
                sendlerId : player.id,
                sentOn : sentOn,
                message,
                name : player.name,
            }
            this.$store.commit('PUSH_MESSAGE', newMessage)
            
            Bus.$emit('sendMessage', chatId, newMessage)
        },
        async botMessages(message){
            const sentOn = moment().format('YYYY-MM-DD HH:mm:ss')
            let newMessage = {
                sendlerId : 'botId',
                sentOn : sentOn,
                message,
                name : 'Huddle Brasil',
                typeMessage : 'bot'
            }
            this.$store.dispatch('pushMessage', newMessage)
        },
        newPlayerMessage(name){
            // console.log("name: ", name)
            const sentOn = moment().format('YYYY-MM-DD HH:mm:ss')
            let newMessage = {
                sendlerId : 'botId',
                sentOn : sentOn,
                message : '',
                name : `${name} ${this.$t("Chat.newPlayerMessage")}`,
                typeMessage : 'new-player'
            }
            // console.log("newMessage: ", newMessage)
            this.$store.dispatch('pushMessage', newMessage)
        },
        playerNew(name){
            // console.log("name: ", name)
            const sentOn = moment().format('YYYY-MM-DD HH:mm:ss')
            let newMessage = {
                sendlerId : 'botId',
                sentOn : sentOn,
                message : '',
                name : `${name} ${this.$t("Chat.newPlayerMessage")}`,
                typeMessage : 'new-player'
            }
            // console.log("newMessage: ", newMessage)
            this.$store.commit('PUSH_MESSAGE', newMessage)
        },
        firstMessages(messages){
            // let arrayMessages = []
            // messages.forEach(async message => {
            //     let messageColor = await this.addColorMessage(message)
            //     arrayMessages.push(messageColor)
            // })
            // this.messages = arrayMessages
            this.messages = messages
            this.scrollToBottom()
            return
        },
        scrollToBottom(){
            if(this.showIconMessage){
                return
            }
            let chatMessages = document.querySelector('.chat-messages');
            let heightChat = this.messages.length * 63;
            if(chatMessages){
                setTimeout(() => {
                    scrollToBottomHelper.scrollTo(chatMessages, chatMessages.scrollHeight  +  heightChat, 500)
                }, 200)
            }
        },
        scrollNewMessage(){
            if(!this.showIconMessage){
                return
            }
            let chatMessages = document.querySelector('.chat-messages');
            let heightChat = this.messages.length * 63;
            if(chatMessages){
                setTimeout(() => {
                    scrollToBottomHelper.scrollTo(chatMessages, chatMessages.scrollHeight  +  heightChat, 500)
                }, 200)
            }
        },
        scrollToTop(){
            let chatMessages = document.querySelector('.chat-messages');
            scrollToBottomHelper.scrollTo(chatMessages, 0, 500)
        },
        toggleIcon(boolean){
            this.showIconMessage = boolean
        },
        addColorMessage(message){
            let members = this.group
            let [ playerMessage ] = members.filter(player => {
                return player.id == message.sendlerId
            })
            message.color = playerMessage.color
            return message
        },
        verifyMessage(message){
            return message.sendlerId != this.currentUser.id ? true : false 
        }
    }
}
</script>
<style lang="scss">

    .chat-body{

        width: 100%;
        height: 100vh;
        padding-top: 55px;
        // background-image: linear-gradient(to top, #282d31, #222629, #1c2022, #16191a, #0f1213);
        background-color:#23272c;
        position: relative;
        display: flex;
        flex-direction: column;

        .chat-open{

            width: 100%;
            background-color: black;
            height: 10vh;
            min-height: 60px;
            position: fixed;
            top: 0;
            z-index: 2;

            .open-letter{

                display: flex;
                align-items: center;
                width: 90%;
                height: 100%;
                margin: 0 auto;

                .chat-icon{

                    height: 40px;
                }

                .chat-title{

                    font-weight: bold;
                    font-size: 15px;
                    color: white;
                    text-transform: uppercase;
                    letter-spacing: 2px;
                    margin-left: 5%;
                }
            }

            .infos-game{
                display: flex;
                justify-content: flex-end;
                width: 75%;
            }
        }

        .chat-messages{

            width: 100%;
            height: calc(100vh - 110px);
            overflow-y: scroll;
            overflow-x: hidden;
            display: flex;
            flex-direction: column;
            align-items: flex-start;
            position: relative;
            
            

            .chat-container{

                width: 100%;
                margin: 10px;
                margin-bottom: 1px;

                &:first-child{

                    margin-top: 10px;        
                }

                &:last-child{

                    margin-bottom: 10px;
                }

                .chat-message{

                    max-width: 85%;
                    background-color: #000000;
                    border-radius: 16px;
                    display: flex;
                    flex-direction: column;
                    padding: 3% 12% 4% 4%;
                    width: max-content;
                    position: relative;
                    

                    .name-message{

                        // color: rgb(255, 115, 0);
                        color: #fff;
                        font-weight: 900;
                        text-transform: uppercase;
                        font-size: 12px;
                        letter-spacing: 1px;
                        width: 100%;
                        display: block;
                    }

                    .message{

                        font-size: 14px;
                        color: #8ea7b1;
                        margin-top: 5px;
                        line-height: 17px;
                    }

                    .hour-message{
                        position: absolute;
                        bottom: 2px;
                        right: 5px;
                        font-size: 10px;
                        color: white;
                    }
                }

                .message-right{

                    background-color: #545e63;
                    margin-left: auto;
                    margin-right: 10px;
                    padding: 10px 5%;
                    border-radius: 60px;

                    .message{

                        color: #b2d1de;
                        word-wrap: break-word;
                        margin: 3px 0;
                    }
                }
            }

            .chat-container-right{
                margin : 5px 10px 0 0;
            }
        }

        .chat-input{
            min-height: 60px;
            position: fixed;
            bottom: 0;
            width: 100%;

            .chat-input-container{

                width: 100%;
                height: 7vh;
                min-height: 60px;
                background-color: #262b2e;
                display: flex;
                align-items: center;
                max-width: 920px;

                .button-emoticon{

                    background-color: transparent;
                    border: none;
                    margin: 0 10px;
                    outline: none;

                    .img-button{
                        height: 25px;
                    }
                }
            }

            .input-message{

                    width: 90%;
                    height: 53px;
                    min-height: 50px;
                    background-color: transparent;
                    padding-left: 5%;
                    padding-right: 55px;
                    outline: none;
                    color: white;
                    font-size: 16px;
                    border: 1px solid gray;
                    margin: 0 auto;
                    border-radius: 30px;
            }

            .send-message{

                width: 40px;
                height: 40px;
                margin-right: 10px;
                // background-color: #9c00ec;
                color: white;
                border: none;
                text-transform: uppercase;
                font-weight: bold;
                font-size: 0.7em;
                letter-spacing: 1px;
                outline: none;
                position: absolute;
                right: 5%;
                border-radius: 50%;
                display: flex;
                align-items: center;
                justify-content: center;

                .img-send{
                    height: 17px;
                }
            }

            .disabled{
                background-color: #474747;
                color: rgb(211, 211, 211);
            }
        }

        .new-message{
            position: fixed;
            bottom: 80px;
            right: 15px;
            z-index: 10;

            .container-circle{
                position: relative;

                .circle-new-messages{

                    width: 22px;
                    height: 22px;
                    border-radius: 50%;
                    background-color: #5cf356;
                    position: absolute;
                    top: -11px;
                    left: -11px;
                    display: flex;
                    justify-content: center;
                    align-items: center;

                    .new-message-counter{
                        color: black;
                        font-size: 12px;
                        font-weight: bold;
                    }
                }
            }

            .btn-new-message{
                background-color: white;
                border: none;
                border-radius: 50%;
                width: 30px;
                height: 30px;
                display: flex;
                align-items: center;
                justify-content: center;
                outline: none;
                cursor: pointer;

                .img-new-message{
                    height: 15px;
                    margin-top: 2px;
                }
            }
        }

        .new-message-open{
            bottom: 60%;
        }
    }

    .chat-body > .chat-body{
        padding-top: 0;
    }

    .new-player-alert{
        margin: 8px auto 10px !important;
        border-radius: 70px !important;
        padding: 3% 8% !important;
        background-color: #fff !important;
        max-width: 75%;
        border-radius: 5px;
        display: flex;
        flex-direction: column;
        width: max-content;
        position: relative;
    }

    .new-player-alert > span{
        color : #000 !important;
        font-size: 14px !important;
    }

    @media only screen and (min-width : 750px) {

        .chat-body{

            max-height: 650px;
            padding-top: 65px;

            .chat-messages{

                height: calc(100% - 55px);

                .chat-container{

                    .chat-message{

                        max-width: 65%;
                        padding: 15px;
                    }
                }
            }

            .chat-input{

                height: 68px;
                position: initial;
                display: flex;
                align-items: center;

                .chat-input-container{
                    height: 55px;
                }

                .input-message{

                    font-size: 16px;
                }

                .send-message{

                    margin-left: 6%;
                    width: 40px;
                    height: 40px;
                    font-size: 0.8em;
                    letter-spacing: 2px;
                }
            }

            .new-message{
                position: absolute;
                bottom: 90px;
                right: 30px;
                z-index: 10;
            }
        }
    }
</style>
